import { useMemo } from 'react'

import { useProductPageUrlParams } from '../../hooks'
import { environment } from '../../../../core/components'

type SkuCache =
  | {
      defaultImage: {
        __ref: string
      }
    }
  | undefined

type DefaultImageCache = Record<string, string> | undefined

export const useSelectedSkuLowResolutionImage = () => {
  const { selectedSkuId } = useProductPageUrlParams()

  const defaultImageUrl = useMemo(() => {
    const store = environment.getStore().getSource()
    const skuCache = store.get(selectedSkuId) as SkuCache

    const defaultImageCache = store.get(
      skuCache?.defaultImage?.__ref ?? ''
    ) as DefaultImageCache

    const defaultImageUrlProp =
      (typeof defaultImageCache === 'object'
        ? Object.keys(defaultImageCache).find((key) => key.startsWith('url'))
        : '') ?? ''

    return defaultImageCache?.[defaultImageUrlProp]
  }, [selectedSkuId])

  return defaultImageUrl
}
